export default __webpack_public_path__ + "static/media/pergola-logo.465681ed.png";